var $faf2a85140263d52$exports = {};
$faf2a85140263d52$exports = {
    "more": `Lis\xe4\xe4 kohteita`
};


export {$faf2a85140263d52$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
